import React, { Component } from "react";
import { MnemoLoading, BoxDanger, Title } from "components/misc";
import { networkErrorHelper } from "libs";

import { MTable } from "components/table";
import { Container } from "design-react-kit";

import { ROUTES } from "const";
import { revisionService } from "libs/api/revisionService";
import { withRouter } from "react-router-dom";

class ReviewPending30Cfu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      rndKey: 0,
      payload: [],
      context: "",
    };

    this.tableConfig.actions[0].onClick = this.handleDetailClick;
  }

  handleDetailClick = (e, value) => {
    const { context } = this.props.match.params;

    const detailRoute = `${ROUTES.EXAMREVIEW_FORM}/${context}/${value}`;
    window.location.href = detailRoute;
  };
  //--- ---

  tableConfig = {
    columns: [
      {
        id: "fullName",
        Header: "Nome e Cognome",
        accessor: "fullName",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      /*{
        id: "createdAt",
        Header: "Data Invio",
        accessor: (row) => {
          return row.createdAt ? dateHelper.toITDate(row.createdAt) : "";
        },
      },*/
      {
        id: "status",
        Header: "Stato",
        accessor: "status",
      },
      {
        id: "competitionClass",
        Header: "Classe Concorso",
        accessor: "competitionClass",
      },
      {
        id: "version",
        Header: "Versione UDA",
        accessor: "version",
      },
      {
        id: "revisionProblem",
        Header: "Problemi",
        accessor: (row) => {
          return row.revisionProblem ? "SI" : "NO";
        },
      },
      {
        id: "revisionProgress",
        Header: "Revisioni",
        accessor: "revisionProgress",
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
      },
    ],
  };

  //--- ---

  componentDidMount() {
    const { context } = this.props;
    this.loadRemote(context);
  }

  componentDidUpdate(prevProps) {
    const { context } = this.props.match.params;

    if (prevProps.match.params.context !== context) {
      this.loadRemote(context);
    }
  }

  loadRemote(context) {
    this.setState({ loading: true, context: context });

    revisionService
      .listAllRevisionPendingExamByRevisorId(context)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.examReview).forEach(([key, val]) => {
          items.push(val);
        });

        this.setState({
          loading: false,
          payload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
          });
        }

        this.setState({ loading: false });
      });
  }

  //--- ---

  render() {
    const { loading, context } = this.state;

    return (
      <>
        <Title>Revisioni non idonee - {context.toUpperCase()}</Title>

        <>
          <hr />
          <section className="my-4">
            {loading ? (
              <MnemoLoading></MnemoLoading>
            ) : (
              <Container>
                <MTable
                  key={this.state.rndKey}
                  tableData={this.state.payload}
                  tableConfig={this.tableConfig}
                />
              </Container>
            )}

            {this.state.payload.length === 0 && (
              <BoxDanger key="nrp-1" className="my-3">
                <div className="small text-info">
                  Non ci sono dati da mostrare in database.
                </div>
              </BoxDanger>
            )}
          </section>
        </>
      </>
    );
  }
}

export default withRouter(ReviewPending30Cfu);
